import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-50">
              韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-700/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-50'
              }`}
            >
              关于我们
            </Link>
            <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700/50 text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
              <i className="ri-search-line"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-50 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-t border-background-700/50">
          <div className="px-4 py-3 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`block px-3 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-700/50'
                }`}
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-700/50 pt-2 mt-2">
              <Link
                to="/about"
                className={`block px-3 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap ${
                  isActive('/about')
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-700/50'
                }`}
              >
                <i className="ri-information-line mr-2"></i>
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}